import {
  apiClient,
  getStoredAuth,
  resolveApiErrorMessage,
} from './authApi';

function withAuthHeaders() {
  const { accessToken } = getStoredAuth();

  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
  };
}

export const productSetupApi = {
  async listProductCommissions(options = {}) {
    const { bustCache = false } = options;

    const response = await apiClient.get('/product-commissions', {
      headers: {
        ...withAuthHeaders(),
        'Cache-Control': 'no-cache, no-store, max-age=0',
        Pragma: 'no-cache',
        Expires: '0',
      },
      ...(bustCache ? { params: { _t: Date.now() } } : {}),
    });

    return response.data;
  },

  async createProductCommission(payload) {
    const response = await apiClient.post('/product-commissions', payload, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },

  async updateProductCommission(productCommissionId, payload) {
    const response = await apiClient.put(`/product-commissions/${productCommissionId}`, payload, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },

  async deleteProductCommission(productCommissionId) {
    const response = await apiClient.delete(`/product-commissions/${productCommissionId}`, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },
};

export function resolveProductSetupApiError(error) {
  return resolveApiErrorMessage(error, 'Failed to process product setup request.');
}
